import { useTranslation } from 'react-i18next';
import { Boxes } from 'lucide-react';
import { Link } from '@/components/ui/link';

const CONTACT_EMAIL = 'zula@derinbay.com';

const SECTION_KEYS = [
  'dataCollected',
  'dataUse',
  'dataStorage',
  'dataSharing',
  'dataRetention',
  'accountDeletion',
  'rights',
] as const;

export function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-muted/40">
      <div className="mx-auto max-w-2xl px-4 py-10">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <Boxes className="h-5 w-5" />
          </div>
          <div>
            <p className="font-semibold">{t('app.name')}</p>
            <p className="text-sm text-muted-foreground">{t('app.tagline')}</p>
          </div>
        </div>

        <h1 className="text-2xl font-semibold">{t('privacy.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('privacy.lastUpdated')}</p>

        <p className="mt-6 text-sm leading-relaxed text-foreground">{t('privacy.intro')}</p>

        <div className="mt-8 space-y-8">
          {SECTION_KEYS.map((key) => (
            <section key={key}>
              <h2 className="text-lg font-semibold">{t(`privacy.${key}Title`)}</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t(`privacy.${key}Body`)}</p>
            </section>
          ))}

          <section>
            <h2 className="text-lg font-semibold">{t('privacy.contactTitle')}</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {t('privacy.contactBody', { email: CONTACT_EMAIL })}
            </p>
          </section>
        </div>

        <div className="mt-10">
          <Link to="/login" intent="quiet">
            {t('privacy.back')}
          </Link>
        </div>
      </div>
    </div>
  );
}
